import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  organizationName: "",
  organization: {},
  dashboardUrl: "",
  breadCrumbs: [],
  selectedRowInfo: {},
  dashboardRoles: [],
  dashboardPermissions: [],
};

const activeDashboardSlice = createSlice({
  name: "activeDashboardSlice",
  initialState,
  reducers: {
    updateActiveDashboardState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetActiveDashboardSlice: () => initialState,
  },
  extraReducers: (builder) => {
    // No extra reducers needed, using builder pattern for RTK 2.0 compatibility
  },
});

export const { updateActiveDashboardState, resetActiveDashboardSlice } =
  activeDashboardSlice.actions;

const { reducer } = activeDashboardSlice;

export default reducer;
